import demoConfig from './environments/demo';
import developmentConfig from './environments/development';
import productionConfig from './environments/production';
import stagingConfig from './environments/staging';
import testingEightConfig from './environments/testing_eight';
import testingFiveConfig from './environments/testing_five';
import testingFourConfig from './environments/testing_four';
import testingNineConfig from './environments/testing_nine';
import testingOneConfig from './environments/testing_one';
import testingSevenConfig from './environments/testing_seven';
import testingSixConfig from './environments/testing_six';
import testingTenConfig from './environments/testing_ten';
import testingThreeConfig from './environments/testing_three';
import testingTwoConfig from './environments/testing_two';
import trainingConfig from './environments/training';

declare global {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  interface Window {
    tot: any;
  }
}

export interface StripePackage {
  title: string;
  subtitle: string;
  offerText: string;
  price: string;
  timeframe: string;
  stripePriceId: string;
}

export interface StripePackages {
  PsychLed: StripePackage;
  CoachingOnly: StripePackage;
  CoachingAndTherapy: StripePackage;
}

export interface TokenOfTrust {
  domain: string;
  publicKey: string;
}

export interface Auth0 {
  domain: string;
  clientId: string;
  audience: string;
}

export interface KeycloakConfig {
  enabled: boolean;
  clientId: string;
  authority: string;
}

export interface OpenReplayConfig {
  enabled: boolean;
  projectKey: string;
  ingestPoint: string;
}

interface CalendlyMeetings {
  onboardingMeetingURL: string;
}

export interface AppConfig {
  /** The unique name of this app - the same as the <app-name> used in scaffolding. */
  appName: string;
  /** the iam configuration */
  auth0: Auth0;
  keycloak: KeycloakConfig;
  /** The base path used for most requests */
  baseApiPath: string;
  /** Root url for an authenticated user. i.e. /home */
  authenticatedRootUrl: string;
  /** Root url for an unauthenticated user. i.e. /login */
  unAuthenticatedRootUrl: string;
  /** Where analytics requests are sent */
  apmUrl?: string;
  /** Which environment to tag analytics with */
  apmEnv: 'development' | 'staging' | 'production';
  openReplayConfig: OpenReplayConfig;

  calendly: CalendlyMeetings;

  /** Reference to the client side id for LaunchDarkly */
  launchDarklyKey: string;
  launchDarklyDisable: boolean;

  /** Our publishable key for Stripe */
  stripeKey: string;
  /** A hash of packages we offer. Eventually, may be hosted by our server */
  stripePackages: StripePackages;
  stripePackagesOneOneTwentyThree: StripePackages;

  /** Endpoint and public keys for token of trust */
  tokenOfTrust: TokenOfTrust;

  /** Ziggeo API Key */
  ziggeoApiKey: string;

  /** Google Analytics  */
  googleMeasurementId?: string;

  /** Stream Chat App id */
  streamChatAppId: string;
  streamChatDisable: boolean;

  /** mopinion / pastease ID */
  pasteTeaseId: string;
}

// If a field in the AppConfig requires customization on a level beyond what
// deployment stage it is in, use an env variable or js.
const config: AppConfig = {
  dev: developmentConfig,
  staging: stagingConfig,
  production: productionConfig,
  test: developmentConfig,
  'testing-one': testingOneConfig,
  'testing-two': testingTwoConfig,
  'testing-three': testingThreeConfig,
  'testing-four': testingFourConfig,
  'testing-five': testingFiveConfig,
  'testing-six': testingSixConfig,
  'testing-seven': testingSevenConfig,
  'testing-eight': testingEightConfig,
  'testing-nine': testingNineConfig,
  'testing-ten': testingTenConfig,
  demo: demoConfig,
  training: trainingConfig,
  testing: {} as unknown as any,
}[
  REACT_APP_STAGE as
    | 'dev'
    | 'staging'
    | 'production'
    | 'testing-one'
    | 'testing-two'
    | 'testing-three'
    | 'testing-four'
    | 'testing-five'
    | 'testing-six'
    | 'testing-seven'
    | 'testing-eight'
    | 'testing-nine'
    | 'testing-ten'
    | 'demo'
    | 'training'
    | 'testing'
];

if (!config) {
  throw new Error(
    'Failed to load AppConfig. Likely an unknown REACT_APP_STAGE  env variable.',
  );
}

export default config;
